import { userRoleTypes } from "@/models/user-role"
import { emailSchema, standardStringSchema } from "@/schemas"
import { z } from "zod"

export const addUserSchema = z.object({
  firstName: standardStringSchema.min(1),
  lastName: standardStringSchema.min(1),
  email: emailSchema,
  role: z.enum(userRoleTypes),
})

export type AddUserSchema = z.infer<typeof addUserSchema>
